import {
  ArrowRightOutlined,
  CheckCircleOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  PhoneOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import SignInScreen from './SignIn.styles';

function AuthPageLayout({ children }) {
  const { pathname } = useLocation();
  const isLogin = pathname === '/';
  return (
    <SignInScreen>
      <aside className="login-story">
        <div className="login-brand">
          <img src={require('../../../../static/img/aidose-login-logo.png')} alt="Aidose" />
          <span>The connected workspace</span>
        </div>
        <div className="story-main">
          <div className="story-eyebrow">Built around your customers</div>
          <h1>
            Every conversation.
            <br />
            <em>
              One connected
              <br />
              workspace.
            </em>
          </h1>
          <p className="story-description">
            Bring your agents, conversations and campaigns together. Make every interaction feel personal.
          </p>
          <div className="conversation-scene" aria-hidden="true">
            <div className="scene-header">
              <div className="scene-title">
                <span className="scene-icon">
                  <MessageOutlined />
                </span>
                A little more connected.
              </div>
              <div className="scene-dots">
                <i />
                <i />
                <i />
              </div>
            </div>
            <div className="message-example">Hi! Can you help me find the right solution for my business?</div>
            <div className="message-example reply">
              Of course. Tell me a little about what you need, and we’ll take it from there.
            </div>
            <div className="scene-agent">
              <CheckCircleOutlined /> A thoughtful response. Every time.
            </div>
            <div className="channel-tags">
              <span>
                <MessageOutlined /> Messaging
              </span>
              <span>
                <PhoneOutlined /> Voice
              </span>
              <span>
                <CustomerServiceOutlined /> Your team
              </span>
            </div>
          </div>
        </div>
        <div className="story-footer">
          <span>Thoughtful technology. Human connections.</span>
          <span>
            <ThunderboltOutlined /> Powered by Aidose
          </span>
        </div>
      </aside>
      <section className="login-panel" aria-label="Account access">
        <div className="login-mobile-brand">
          <img src={require('../../../../static/img/aidose-login-logo.png')} alt="Aidose" />
        </div>
        <div className="login-topline">
          {isLogin ? 'New to Aidose?' : 'Already have an account?'}{' '}
          <Link to={isLogin ? '/register' : '/'}>
            {isLogin ? 'Create an account' : 'Sign in'} <ArrowRightOutlined />
          </Link>
        </div>
        <div className="login-form-area">{children}</div>
        <footer className="login-panel-footer">© {new Date().getFullYear()} Aidose. All rights reserved.</footer>
      </section>
    </SignInScreen>
  );
}
AuthPageLayout.propTypes = { children: PropTypes.node.isRequired };
export default AuthPageLayout;
